import { Api } from 'argon-common';
import config from './config';

var apiOptions = {
    isDebug: config.isDebug,
    hostName: config.hostName
}

export default new Api(apiOptions);
